import { getSms } from '@/api/login'
export default {
    data() {
        return {
            timer:null,
            codeTime:0
        }
    },
    methods: {
        // 获取短信验证码
        getSmsCode(obj){
            this.codeTime = 60
            this.timer = setInterval(()=>{
                this.codeTime-=1
                this.codeTime==0&&this.clearTimer()
            },1000)
            this.getSms(obj)
        },
        getSms(obj){
            getSms(obj).then(res=>{
                if(res.code==1){
                    this.$toast({
                        type: 'success', // type类型：success || error || warning
                        message: '验证码发送成功',
                        duration: 3000
                    })
                }
            }).catch(err=>{
                this.codeTime=0
                this.clearTimer()
                if(err.data.code==106){
                    this.isImgCode = true
                }
            })
        },
        // 清除定时器
        clearTimer(){
            this.codeTime = 0
            clearInterval(this.timer)
        },
        
    }
}